/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Phase_WaitingInputs */

const en_welcome_phase_waiting = /** @type {(inputs: Welcome_Phase_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting RMF services`)
};

const fr_welcome_phase_waiting = /** @type {(inputs: Welcome_Phase_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrage des services RMF`)
};

const ms_sg2_welcome_phase_waiting = /** @type {(inputs: Welcome_Phase_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memulakan perkhidmatan RMF`)
};

/**
* | output |
* | --- |
* | "Starting RMF services" |
*
* @param {Welcome_Phase_WaitingInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const welcome_phase_waiting = /** @type {((inputs?: Welcome_Phase_WaitingInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Phase_WaitingInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_welcome_phase_waiting(inputs)
	if (locale === "fr") return fr_welcome_phase_waiting(inputs)
	return ms_sg2_welcome_phase_waiting(inputs)
});